module.exports = "pegasus/assets/theme4/medium/2.jpg";